module.exports = __webpack_public_path__ + "img/bigFont.075b1ebf.svg";